import { Add } from '@mui/icons-material'
import { Button } from '@mui/material'
import React from 'react'

interface SubmitTranslationProps {
  buttonText?: string;
  onSubmit: () => void;
  icon?: React.ReactNode | false;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
}

const SubmitTranslation: React.FC<SubmitTranslationProps> = ({ 
  buttonText = 'Submit new translation',
  onSubmit,
  icon = <Add />,
  disabled = false,
  variant = 'text'
}) => {
  return (
    <Button
      variant={variant}
      startIcon={icon !== false ? icon : undefined}
      onClick={onSubmit}
      disabled={disabled}
    >
      {buttonText}
    </Button>
  )
}

export default SubmitTranslation;